import { TennisScore } from "../../models/index";
/* Logic extracting tennis specific data */

// TODO: Need to be refactored - copied from the mobile solution
var isLiveBettingPage = 0;
export class TennisScoreParser {

    /* tslint:disable */
    /* istanbul ignore next */
    public static parseData(score1: string, score2: string) : TennisScore {
        let tennisData;

        if (score1 === undefined || score2 === undefined)
        {
            return TennisScore.createEmptyTennisScore();
        }

        if (score1.charAt(score1.length - 1) === "1")
        {
            if (score2.charAt(score2.length - 1) === "2") {
                tennisData = this.createTennisDataProps(score1, score2, 3, false);
            }
            else if (score2.charAt(score2.length - 1) === "3") {
                tennisData = this.createTennisDataProps(score1, score2, 3, true);
                 }
            else if (score2.charAt(score2.length - 1) === "4") {
                tennisData = this.createTennisDataProps(score1, score2, 5, false);
                 }
            else if (score2.charAt(score2.length - 1) === "5") {
                tennisData = this.createTennisDataProps(score1, score2, 5, true);
                 }
        }
        else
        {
            if (score1.charAt(score1.length - 1) === "2") {
                tennisData = this.createTennisDataProps(score1, score2, 3, false);
            }
            else if (score1.charAt(score1.length - 1) === "3") {
                tennisData = this.createTennisDataProps(score1, score2, 3, true);
                 }
            else if (score1.charAt(score1.length - 1) === "4") {
                tennisData = this.createTennisDataProps(score1, score2, 5, false);
                 }
            else if (score1.charAt(score1.length - 1) === "5") {
                tennisData = this.createTennisDataProps(score1, score2, 5, true);
                 }
        }

        if (tennisData === undefined) {
            tennisData = TennisScore.createEmptyTennisScore();
        }

        return tennisData;
    }

    /* tslint:disable */
    /* istanbul ignore next */
    private static createTennisDataProps(score1, score2, matchType, lastSetIsAdvantageSet) {
        let data = new TennisScore(TennisScore.createEmptyTennisScore());
        data.matchType = matchType;
        data.lastSetIsAdvantageSet = lastSetIsAdvantageSet;

        if (score1.charAt(score1.length - 1) === "1") {
            data.servs = 0;
        }
        else if (score2.charAt(score2.length - 1) === "1") {
            data.servs = 1;
        }

        var startIndex = score1.length - 3;
        if (startIndex >= 0)
        {
            data.player1Points = parseInt(score1.substr(startIndex, 2));
            if (parseInt(data.player1Points) > 40) {
                data.player1Points = "A";
            }

            // Set 1
            startIndex = score1.length - 4;
            if (startIndex >= 0)
            {
                var set1 = score1.substr(startIndex, 1);
                if (set1) {
                    data.player1Set1 = parseInt(set1);
                }

                // Set 2
                startIndex = score1.length - 5;
                if (startIndex >= 0)
                {
                    var set2 = score1.substr(startIndex, 1);
                    if (set2) {
                        data.player1Set2 = parseInt(set2);
                    }

                    // Set 3
                    startIndex = score1.length - 7;
                    if (startIndex >= -1)
                    {
                        var set3;
                        if (startIndex === -1) {
                            set3 = score1.substr(0, 1);
                        }
                        else {
                            set3 = score1.substr(startIndex, 2);
                        }
                        if (set3) {
                            data.player1Set3 = parseInt(set3);
                        }

                        // Set 4
                        startIndex = score1.length - 8;
                        if (startIndex >= 0)
                        {
                            var set4 = score1.substr(startIndex, 1);
                            if (set4) {
                                data.player1Set4 = parseInt(set4);
                            }

                            // Set 5
                            if (startIndex > 0)
                            {
                                var set5 = score1.substr(0, startIndex);
                                if (set5) {
                                    data.player1Set5 = parseInt(set5);
                                }
                            }
                        }
                    }
                }
            }
        }

        startIndex = score2.length - 3;
        if (startIndex >= 0)
        {
            data.player2Points = parseInt(score2.substr(startIndex, 2));
            if (parseInt(data.player2Points) > 40) {
                data.player2Points = "A";
            }

            startIndex = score2.length - 4;
            if (startIndex >= 0)
            {
                // Set 1
                set1 = score2.substr(startIndex, 1);
                if (set1) {
                    data.player2Set1 = parseInt(set1);
                }

                startIndex = score2.length - 5;
                if (startIndex >= 0)
                {
                    // Set 2
                    set2 = score2.substr(startIndex, 1);
                    if (set2) {
                        data.player2Set2 = parseInt(set2);
                    }

                    startIndex = score2.length - 7;
                    if (startIndex >= -1)
                    {
                        // Set 3
                        if (startIndex === -1) {
                            set3 = score2.substr(0, 1);
                        }
                        else {
                            set3 = score2.substr(startIndex, 2);
                        }
                        if (set3) {
                            data.player2Set3 = parseInt(set3);
                        }

                        startIndex = score2.length - 8;
                        if (startIndex >= 0)
                        {
                            // Set 4
                            set4 = score2.substr(startIndex, 1);
                            if (set4) {
                                data.player2Set4 = parseInt(set4);
                            }

                            // Set 5
                            if (startIndex > 0)
                            {
                                set5 = score2.substr(0, startIndex);
                                if (set5) {
                                    data.player2Set5 = parseInt(set5);
                                }
                            }
                        }
                    }
                }
            }
        }

        // Setting uninitialized games values
        // Points
        if (data.player1Points === "" && data.player2Points !== "") {
            data.player1Points = "0";
        }

        if (data.player1Points !== "" && data.player2Points === "") {
            data.player2Points = "0";
        }

        // Set 1
        if (data.player1Set1 === "" && data.player2Set1 !== "") {
            data.player1Set1 = "0";
        }

        if (data.player1Set1 !== "" && data.player2Set1 === "") {
            data.player2Set1 = "0";
        }

        // Set 2
        if (data.player1Set2 === "" && data.player2Set2 !== "") {
            data.player1Set2 = "0";
        }

        if (data.player1Set2 !== "" && data.player2Set2 === "") {
            data.player2Set2 = "0";
        }

        // Set 3
        if (data.player1Set3 === "" && data.player2Set3 !== "") {
            data.player1Set3 = "0";
        }

        if (data.player1Set3 !== "" && data.player2Set3 === "") {
            data.player2Set3 = "0";
        }

        // Set 4
        if (data.player1Set4 === "" && data.player2Set4 !== "") {
            data.player1Set4 = "0";
        }

        if (data.player1Set4 !== "" && data.player2Set4 === "") {
            data.player2Set4 = "0";
        }

        // Set 5
        if (data.player1Set5 === "" && data.player2Set5 !== "") {
            data.player1Set5 = "0";
        }

        if (data.player1Set5 !== "" && data.player2Set5 === "") {
            data.player2Set5 = "0";
        }

        // Defining sets score
        if (data.player1Set1 !== "" && data.player2Set1 !== "")
        {
            var set1Winner = this.getSetWinner(data.player1Set1, data.player2Set1);
            if (set1Winner > 0) {
                data.scoreSetsPlayer1++;
            }
            else if (set1Winner < 0) {
                data.scoreSetsPlayer2++;
                 }

            if (data.player1Set2 !== "" && data.player2Set2 !== "")
            {
                var set2Winner = this.getSetWinner(data.player1Set2, data.player2Set2);
                if (set2Winner > 0) {
                    data.scoreSetsPlayer1++;
                }
                else if (set2Winner < 0) {
                    data.scoreSetsPlayer2++;
                     }

                if (data.player1Set3 !== "" && data.player2Set3 !== "")
                {
                    var set3Winner;

                    if (!isLiveBettingPage)
                    {
                        if (data.matchType === 3)
                            set3Winner = this.getLastSetSetWinner(data.player1Set3, data.player2Set3, data.lastSetIsAdvantageSet);
                        else
                            set3Winner = this.getSetWinner(data.player1Set3, data.player2Set3);
                    }
                    else
                    {
                        set3Winner = this.getSetWinner(data.player1Set3, data.player2Set3);
                    }

                    if (set3Winner > 0) {
                        data.scoreSetsPlayer1++;
                    }
                    else if (set3Winner < 0) {
                        data.scoreSetsPlayer2++;
                         }

                    if (data.player1Set4 !== "" && data.player2Set4 !== "")
                    {
                        var set4Winner = this.getSetWinner(data.player1Set4, data.player2Set4);
                        if (set4Winner > 0) {
                            data.scoreSetsPlayer1++;
                        }
                        else if (set4Winner < 0) {
                            data.scoreSetsPlayer2++;
                             }

                        if (data.player1Set5 !== "" && data.player2Set5 !== "")
                        {
                            if (isLiveBettingPage)
                            {
                                var set5Winner = this.getLastSetSetWinner(data.player1Set5, data.player2Set5, data.lastSetIsAdvantageSet);
                            }
                            else
                            {
                                var set5Winner = this.getSetWinner(data.player1Set5, data.player2Set5);
                            }
                            if (set5Winner > 0) {
                                data.scoreSetsPlayer1++;
                            }
                            else if (set5Winner < 0) {
                                data.scoreSetsPlayer2++;
                            }
                        }
                    }
                }
            }
        }
        
        return data;
    }

    /* tslint:disable */
    /* istanbul ignore next */
    private static getSetWinner(gamesPlayer1, gamesPlayer2)
    {
        if (Math.abs(gamesPlayer1 - gamesPlayer2) > 1)
        {
            if (gamesPlayer1 >= 6) { // Player 1 wins the set
                return 2;
            }
            else if (gamesPlayer2 >= 6) { // Player 2 wins the set
                return -2;
                 }
        }
        else if (Math.abs(gamesPlayer1 - gamesPlayer2) === 1)
        {
            if (gamesPlayer1 === 7) {
                return 1;
            }
            else if (gamesPlayer2 === 7) {
                return -1;
                 }
        }
        return 0;
    }

    /* tslint:disable */
    /* istanbul ignore next */
    private static getLastSetSetWinner(gamesPlayer1, gamesPlayer2, lastSetIsAdvantageSet)
    {
        if (Math.abs(gamesPlayer1 - gamesPlayer2) > 1)
        {
            if (gamesPlayer1 >= 6) // Player 1 wins the set
                return 2;
            else if (gamesPlayer2 >= 6) // Player 2 wins the set
                return -2;
        }
        else if (Math.abs(gamesPlayer1 - gamesPlayer2) === 1)
        {
            if (lastSetIsAdvantageSet)
            {
                return 0;
            }
            else
            {
                if (gamesPlayer1 === 7)
                    return 1;
                else if (gamesPlayer2 === 7)
                    return -1;
            }
        }
        return 0;
    }
}